import React, { useEffect } from "react";
import style from "./style.module.css";
import IcWhatsapp from "../../components/Svg/IcWhatsapp";
import Tooltip2 from "../Tooltip";

const HeaderTrainee = props => {
  const { profile } = props;
  const commercial = profile.commercials;
  return (
    <>
      <div className={style.Header}>
        <div className={style.content}>
          {commercial.institution && (
            <div className={style.info}>
              <h2 className="form-title">{profile.name}</h2>
              <p className="m-0">
                {commercial.course.title} {commercial.year}.{commercial.period} • {commercial.institution.title}
              </p>
            </div>
          )}
          <div className={style.controles}>
            {!!commercial?.whatsapp_link && (
              <Tooltip2 tip="Grupo da Turma">
                <a href={commercial?.whatsapp_link} target="_blank">
                  <IcWhatsapp />
                </a>
              </Tooltip2>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderTrainee;
